import { ISendMessageRequest } from '../../repositories/cian-chat-bot/entities/send_message/SendMessageRequest';
import {
  fetchPublicMobileV1SendMessage,
  TPublicMobileV1SendMessageResponse,
} from '../../repositories/cian-chat-bot/mobile/v1/send-message';
import { TContext } from '../../types/context';
import { EExceptionDomain } from '../../types/exceptionDomains';
import { getGenericLikeError } from '../../utils/logging/getGenericLikeError';
import { getResponseError } from '../../utils/logging/getResponseError';
import { mapChatbotMessageToChatMessage } from '../../utils/mapChatbotMessageToChatMessage';

export type { ISendMessageRequest as TChatbotSendMessageParams };

const DEFAULT_ERROR_MESSAGE = 'Ошибка при отправке сообщения в чатбот';

export async function chatbotSendMessage({ httpApi, logger }: TContext, parameters: ISendMessageRequest) {
  try {
    const { response, statusCode }: TPublicMobileV1SendMessageResponse = await fetchPublicMobileV1SendMessage({
      httpApi,
      parameters,
    });

    if (statusCode !== 200) {
      throw getResponseError({
        domain: EExceptionDomain.Chatbot,
        response,
        defaultMessage: DEFAULT_ERROR_MESSAGE,
        statusCode,
      });
    }

    return mapChatbotMessageToChatMessage(response.message);
  } catch (error) {
    const exception = getGenericLikeError({
      error,
      domain: EExceptionDomain.Chatbot,
      message: DEFAULT_ERROR_MESSAGE,
    });

    logger.error(exception, {
      microserviceName: 'cian-chat-bot',
      pathApi: '/mobile/v1/send-message/',
      parameters: JSON.stringify(parameters),
    });

    return null;
  }
}
